import { Component, OnInit, Injector } from '@angular/core';
import { TenantDashboardServiceProxy } from '@shared/service-proxies/service-proxies';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';
import * as moment from 'moment';


class DashboardTopStats extends DashboardChartBase {

  totalProfit = 0; totalProfitCounter = 0;  
  totalProfitChange = 0; totalProfitChangeCounter = 0;
  
  init(totalProfit, totalProfitChange) {
    this.totalProfit = totalProfit;
    this.totalProfitChange = totalProfitChange;
    this.hideLoading();
  }
}

@Component({
  selector: 'app-widget-general-total-profit',
  templateUrl: './widget-general-total-profit.component.html',
  styleUrls: ['./widget-general-total-profit.component.css']
})
export class WidgetGeneralTotalProfitComponent extends WidgetComponentBase implements OnInit {

  dashboardTopStats: DashboardTopStats;
  selectedDateRange: moment.Moment[] = [moment().startOf('year'), moment().endOf('day')];  

  showNewRegistrations = false;
  showNewAnnuities = false;
  
  constructor(injector: Injector,
    private _tenantDashboardServiceProxy: TenantDashboardServiceProxy
  ) {
    super(injector);
    this.dashboardTopStats = new DashboardTopStats();
  }

  ngOnInit() {
    this.checkPermissions()
    this.subDateRangeFilter();
    this.runDelayed(this.loadTopStatsData);
  }
  checkPermissions(): void {
    this.showNewRegistrations = this.isGranted('Pages.Event.Tenant.Events.Management') && this.feature.isEnabled('App.EventsFeature');
    this.showNewAnnuities = this.isGranted('Pages.Annuity.Tenant.Annuities.Management') && this.feature.isEnabled('App.AnnuitiesFeature');
  }

  loadTopStatsData = () => {
    this._tenantDashboardServiceProxy.getGeneralTotalProfit(this.selectedDateRange[0], this.selectedDateRange[1], undefined).subscribe((data) => {
      this.dashboardTopStats.init(data.total, data.totalChange);
    });
  }

  onDateRangeFilterChange = (dateRange) => {
    if (!dateRange || dateRange.length !== 2 || (this.selectedDateRange[0] === dateRange[0] && this.selectedDateRange[1] === dateRange[1])) {
      return;
    }

    this.selectedDateRange[0] = dateRange[0];
    this.selectedDateRange[1] = dateRange[1];
    this.runDelayed(this.loadTopStatsData);
  }

  subDateRangeFilter() {
    abp.event.on('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  unSubDateRangeFilter() {
    abp.event.off('app.dashboardFilters.dateRangePicker.onDateChange', this.onDateRangeFilterChange);
  }

  ngOnDestroy(): void {
    this.unSubDateRangeFilter();
  }
}
